//记得在 src\components\lang\zhLoad.js 里面添加对象
const client= {
  clientId:"应用编码",
  clientName: '应用名称',
  resourceIds:'资源服务',
  clientSecret:'签名密钥',
  accessTokenValidity:'Token(秒)',
  refreshTokenValidity:'Refresh(秒)',
  scope:'访问范围',
  authorities:'API权限',
  remark:'备注',
  addClient:'新增应用',
  editClient:'修改应用',
  editSecret:'修改密钥',
  resetSecret:'重置密钥',
  oldClientSecret:'当前密钥',
  newClientSecret:'输入新密钥',
  rewriteSecret:'再次输入',
  exportData:'导出数据',
  initPwd:'用户密码',
  init_client_info:'导入应用缓存',
  init_user_info:'导入用户缓存',
  init_menu_info:'导入菜单缓存',
  init_role_info:'导入角色缓存',
  init_permission_info:'导入权限缓存',
  init_page_op_info:'导入按钮缓存',
    msg:{
      clientName:'请输入应用名称',
      clientId:"请输入应用编码",
      resourceIds:'请输入资源服务器编码',
      clientSecret:'请输入签名密钥',
      accessTokenValidity:'请输入accessToken过期时间',
      refreshTokenValidity:'请输入refreshToken过期时间',
      scope:'请输入访问范围',
      currentPwd:'请输入当前密钥',
      newPwd:'请输入新密钥',
      enterAgain:'请再次输入新密钥',
      initPwd:'请输入用户初始化密码',
    }
};
export default client



// WEBPACK FOOTER //
// ./src/page/bd/orderMivManualNotice/lang/orderMivManualNotice.zh.js